import React from "react";
import { withRouter, Link } from "react-router-dom";
import "./Button.css";
class BackButton extends React.Component {
  //Save this functionality for later. Just making this a regular link.
  // goBack = event => {
  //     this.props.history.goBack();
  // }
  // onClick={this.goBack}

  render() {
    return (
      <div className="back-button">
        <Link className="button-class" to={this.props.path}>
          {"<"} Back
        </Link>
      </div>
    );
  }
}

export default withRouter(BackButton);
